/** Зона на случай, когда браузер свою не назвал: единственная, которая есть в любом списке IANA. */
export const FALLBACK_TIME_ZONE = 'UTC';

/**
 * IANA-зона браузера (`Europe/Moscow`, `Asia/Novosibirsk`) — не смещение: смещение не
 * знает перехода на летнее время, а зона знает.
 *
 * `resolvedOptions().timeZone` бывает пустым в старых движках и в окружениях без ICU,
 * а сам `Intl` может отсутствовать вовсе — тогда `UTC`, а не `undefined` в запросе.
 */
export function getBrowserTimeZone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || FALLBACK_TIME_ZONE;
  } catch {
    return FALLBACK_TIME_ZONE;
  }
}
